import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import { parseOauthCallback } from "utils/oauth";
import { connect } from "react-redux";
import { newOauthTokenAction } from "actions/oauth-actions";
import { Loading } from "components/common/loading";

class OauthPage extends React.Component {
  componentWillMount() {
    const hash = R.path(["location", "hash"], this.props);
    const data = parseOauthCallback(hash);
    this.props.onNewOauthToken(data);
  }

  render() {
    return <Loading />;
  }
}

OauthPage.propTypes = {
  onNewOauthToken: PropTypes.func.isRequired // ({ token: string, state: string }) => void
};

const matchStateToProps = () => ({});

const matchDispatchToProps = (dispatch) => ({
  onNewOauthToken: (data) => {
    dispatch(newOauthTokenAction(data));
  }
});

export const OauthContainer = connect(matchStateToProps, matchDispatchToProps)(OauthPage);



// WEBPACK FOOTER //
// ./src/js/containers/oauth-container.jsx